const getters = {
    salesperson: (state) => state.salesperson,
    loading: state => state.loading
};

export default getters;